import angular from 'angular'
import Components from './components'
import Dialog from './dialog'
import Directives from './directives'
import Notifications from './notifications'

export default angular.module('rb.ng-ui', [ Components, Dialog, Directives, Notifications])
